import { PortModel } from '../../Port';

import { NodeModel as NM } from '@projectstorm/react-diagrams';

export default class NodeModel extends NM {
  constructor(diagramNodeType, id, index) {
    super({ type: "NG_INSIGHT_DIAGRAM_NODE", diagramNodeType, id, index });
    this.addNgPort({ input: false, name: "ConnectionOutput" })
    this.addNgPort({ input: true, name: "ConnectionInput" })
  }

  addNgPort = ({ input, name }) => this.addPort(new PortModel({ input, name }))

  getId = () => this.options.id
  getTileIndex = () => this.options.index
  getDiagramType = () => this.options.diagramNodeType
}
